import { render, staticRenderFns } from "./WorkspaceCreated.vue?vue&type=template&id=00be687a&scoped=true&lang=html"
import script from "./WorkspaceCreated.vue?vue&type=script&lang=js"
export * from "./WorkspaceCreated.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceCreated.vue?vue&type=style&index=0&id=00be687a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00be687a",
  null
  
)

export default component.exports